module.exports = __webpack_public_path__ + "img/1.f2bccfe5.jpg";